<template>
    <div>
      <list
        row-key="RecordId"
        ref="list"
        unit="推广奖励设置"
        :expand-all-row="true"
        :page="page"
        :query-params="params"
        :show-checkbox="$permission.canDel()"
        :show-query="showQuery"
        :get-data-func="getDataFunc"
      >
        <template slot="toolbar-right">
          <slot name="toolbar-right"></slot>
        </template>
        <template slot="query">
         
          <el-form-item label="奖励类型">
            <el-select v-model="params.RewardType" placeholder="请选择奖励类型" clearable>
              <el-option label="注册会员" :value="1"></el-option>
              <el-option label="消费" :value="0"></el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="状态">
            <el-select v-model="params.State" placeholder="请选择状态" clearable>
              <el-option label="启用" :value="1"></el-option>
              <el-option label="停用" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="table">
        
          <el-table-column prop="RewardType" label="奖励类型" />
          <el-table-column prop="RewardUnit" label="奖励计数单位" />
           <el-table-column prop="RewardRange" label="奖励计数范围" />
           <el-table-column prop="RewardMoney" label="获得奖励金额" />
          <el-table-column prop="State" width="80px" label="状态" align="center">
            <template slot-scope="{row}">
              <el-tag type="success" v-if="row.State == 1">启用</el-tag>
              <el-tag type="danger" v-else>停用</el-tag>
            </template>
          </el-table-column>
          <!-- slot[column] -->
          <slot name="column"></slot>
          <!--/ slot[column]-->
        </template>
      </list>
    </div>
  </template>
  <script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  
  export default {
    mixins: [listMixin],
    components: { list },
    data() {
      return {
       // api: require("@/api/person/persongrade").default,
        params: {
          RewardType: "",
          State: null,
        },
      };
    },
    methods: {

    getDataFunc(params) {
      return new Promise((resolve,reject) => {
        resolve({ Data: [{RewardType:"注册会员",RewardUnit:"人",RewardRange:"1",RewardMoney:"2",State:1},{RewardType:"会员消费",RewardUnit:"元",RewardRange:"100-200",RewardMoney:"2",State:1}]});
      })
    },
     
    },
  };
  </script>